import { render, staticRenderFns } from "./Subtree.vue?vue&type=template&id=47e644c1&scoped=true&"
import script from "./Subtree.vue?vue&type=script&lang=js&"
export * from "./Subtree.vue?vue&type=script&lang=js&"
import style0 from "./Subtree.vue?vue&type=style&index=0&id=47e644c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e644c1",
  null
  
)

export default component.exports